<template>
  <div class="" v-show="tabledata">
    <div class="vtable-grid inside-box" ref="gridContainer">
      <ul class="">
        <template v-for="(item, index) in tabledata.items">
          <li @click="selectRow(item, $event)">
            <template :class="`${column.type}-line`" v-for="(column, indexColumn) in tabledata.columns" :key="indexColumn">
              <slot v-if="column.key == 'name'" :name="`column_${column.key}`" :item="item" onclick="return false"/>
              <slot v-if="column.type == 'custom'" :name="`column_${column.key}`" :item="item" onclick="return false"/>
              <span v-if="column.type == 'externalDate'" :class="column.type">{{ formatDate(item, column.value) }}</span>
              <span v-if="column.type == undefined || column.type == 'string' && column.key != 'name'" onclick="return false">{{ getValue(item, column.value) }}</span>
            </template>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.btn-load {
  color:                          var(--Brand-Primary);
  display:                        block;
  margin:                         0 auto;
  padding:                        10px 20px;
  background:                     var(--Shades-BG);
  border:                         1px solid var(--Shades-30-Border);
}
</style>

<script>
import { useExamFilterStore } from '@/store/examFilter'

export default {
  name: 'BaseTable',
  props: ['tabledata'],
  data: () => ({
    dateFormat: "",
    previousScrollHeight: null,
  }),
  watch: {
    'tabledata.items'(newItems, oldItems) {
      const gridContainer = this.$refs.gridContainer;
      gridContainer.scrollTop = 0;
    },
  },
  computed: {
    isExamRoute() {
      return this.$router.currentRoute._value.name == 'exam-list'
    }
  },
  mounted: function() {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    this.dateFormat = this.$i18n.t('dateTimeFormat')
  },
  methods: {
    getValue(data, key) {
      return _.get(data, key)
    },
    formatDate(data, key) {
      let value = _.get(data, key)
      let result = moment(value).format(this.dateFormat);
      return result
    },
    selectRow(item, event) {
      let isCommandPressed = event.ctrlKey || (event.button === 1)
      this.$emit('item-opened', {item: item, commandPressed: isCommandPressed})
    },
    // @deprecated
    checkStatus(status) {
      if (status === 'Closed' || status === 'Fechado' || status === 'closed' || status === 'fechado')
        return 'label-closed';

      return 'label-open';
    },
  },
  beforeDestroy() {
    this.$refs.scrollContainer.removeEventListener('scroll', this.onScroll);
  }
}
</script>
